import Skeleton from "@/components/skeleton/Skeleton";

export default function SkeletonWrapper() {
  return (
    <div className="flex h-full flex-col justify-between pb-9 px-4.5">
      <div>
        <Skeleton className="h-6 w-[70%] rounded-md" />
        <Skeleton className="mt-6 h-5 w-full rounded-md" />
        <Skeleton className="mt-2 h-5 w-full rounded-md" />
      </div>
      <Skeleton className="h-12 w-full rounded-full" />
    </div>
  );
}
